import * as React from "react";
import { IClient, IFeesCalculated } from "intake_shared/src/types";
import { Input } from "../../../../bits/Input/Input";
import InsuranceForm from "../../edit-client/InsuranceForm/InsuranceForm";
import { Card } from "../../../../bits/Card/Card";
import InsuranceValues from "../InsuranceValues/InsuranceValues";
import InsuranceCardUpload from "../InsuranceCardUpload/InsuranceCardUpload";
import {
    TUpdateClient,
    TUpdateClientByStatus,
    TUpdateMultipleClientFieldsByStatus,
} from "../../../../../../types";

interface InsuranceVerificationProps {
    client: IClient;
    updateClient: TUpdateClient;
    updateClientByStatus: TUpdateClientByStatus;
    updateMultipleClientFieldsByStatus: TUpdateMultipleClientFieldsByStatus;
}

export default function InsuranceVerification({
    client,
    updateClient,
    updateClientByStatus,
    updateMultipleClientFieldsByStatus,
}: InsuranceVerificationProps) {
    const [feesCalculated, setFeesCalculated] = React.useState<IFeesCalculated>();
    const [autoFillFees, setAutoFillFees] = React.useState(false);

    return (
        <>
            <Card>
                <p className="sectionTitle">Personal Information</p>
                <form
                    onSubmit={async (e) => {
                        e.preventDefault();
                    }}
                    className="v2-form"
                >
                    <div className="gridThree">
                        <Input
                            label="First name"
                            value={client.first_name}
                            onChange={(e) => {
                                updateClient("first_name", e.target.value);
                            }}
                        />
                        <Input
                            label="Last name"
                            value={client.last_name}
                            onChange={(e) => {
                                updateClient("last_name", e.target.value);
                            }}
                        />
                        <Input
                            label="Preferred name"
                            value={client.preferred_name}
                            onChange={(e) => {
                                updateClient("preferred_name", e.target.value);
                            }}
                        />
                    </div>
                    <InsuranceForm
                        client={client}
                        updateClient={updateClient}
                        updateMultipleClientFieldsByStatus={
                            updateMultipleClientFieldsByStatus
                        }
                        viewingInsuranceVerification={true}
                    />
                </form>
            </Card>
            <InsuranceValues
                showLicFees={false}
                client={client}
                updateClientByStatus={updateClientByStatus}
                setFeesCalculated={setFeesCalculated}
                setAutoFillFees={setAutoFillFees}
                updateClient={updateClient}
                feesCalculated={feesCalculated}
                autoFillFees={autoFillFees}
                updateMultipleClientFieldsByStatus={
                    updateMultipleClientFieldsByStatus
                }
            />
            <InsuranceCardUpload
                client={client}
                updateClientByStatus={updateClientByStatus}
            />
        </>
    );
}
